/* eslint-disable func-names */
import tmsMdmAxiosInstance from '@/tms-mdm-axios';

import bdrAxios from '../axios-bdr';


function getAxiosBySection(section) {
  return section === 'bfr' ? bdrAxios : tmsMdmAxiosInstance;
}

const sectionMieone = {
  carton: 'carton',
  carrier: 'carrier',
  shipmethod: 'shipmethod',
};

export const search = async ({ section, params }) => {
  try {
    const axiosInstance = getAxiosBySection(section);
    const result = await axiosInstance(`/${section}/search`, { params });
    return result && result.data;
  } catch (error) {
    throw error;
  }
};

export const update = async ({ section, Id, data }) => {
  try {
    const result = await tmsMdmAxiosInstance.put(`/${section}/${Id}`, { data });
    return result && result.data;
  } catch (error) {
    throw error;
  }
};

export const create = async ({ section, data }) => {
  try {
    const result = await tmsMdmAxiosInstance.post(`/${section}`, { data });
    return result && result.data;
  } catch (error) {
    throw error;
  }
};

export const remove = async ({ section, data }) => {
  try {
    const result = await tmsMdmAxiosInstance.delete(`/${section}/${data.id}`, { data });
    return result && result.data;
  } catch (error) {
    throw error;
  }
};
